import { render, staticRenderFns } from "./ListExtracts.vue?vue&type=template&id=2eaafca9"
import script from "./ListExtracts.vue?vue&type=script&lang=js"
export * from "./ListExtracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports